import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Files } from '../../../shared/services/files/files';
import { NavigationFeedbackService } from '../../services/navigation-feedback/navigation-feedback';

export const fileGuard: CanActivateFn = (route, state) => {

  const file = inject(Files);
  const router = inject(Router);
  const feedback = inject(NavigationFeedbackService);
  const uploadedFiles = file.uploadedFiles();
  if(uploadedFiles.length === 0){
    feedback.notify('Select an OEM first');
    router.navigate(['home']);
    return false;
  }
  return true;
};
